import { gql } from "@apollo/client";

export const AddUserItemDocument = gql`
  mutation AddUserItem(
    $image: Upload!
    $removeBG: Boolean
    $tags: [String!]
    $productIds: [ID!]
  ) {
    addUserItem(
      image: $image
      removeBG: $removeBG
      tags: $tags
      productIds: $productIds
    ) {
      id
      images
      tags
      productIds
      sourceProductId1
      sourceProductId2
    }
  }
`;
